import Aboutus from './Components/Aboutus';
import Home from './Components/Home';
import Navbar from './Components/Navbar';
import {BrowserRouter as Router,Route, Routes} from 'react-router-dom';
import Services from './Components/Services';
import Contactus from './Components/Contactus';
import Index from './Components/Index';
import packageJson from "../package.json";
import { useEffect } from 'react';


function App() {
  
  useEffect(() => {
      const checkVersion = async () => {
        try {
          const response = await fetch("/version.json", {
            cache: "no-store"
          });
          const data = await response.json();
          const serverVersion = data.version;
          console.log("serverrrrrrr",serverVersion)
          const localVersion = localStorage.getItem("app_version");
          console.log("locallllllllll",localVersion)
          // First time visit
          if (!localVersion) {
            localStorage.setItem("app_version", serverVersion);
            return;
          }
          // If version changed
          if (localVersion !== serverVersion) {
            localStorage.setItem("app_version", serverVersion);
            window.location.reload();
          }
        } catch (error) {
          console.error("Version check failed:", error);
        }
      };
      checkVersion();
    }, []);

  return (
    <Router>
      <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/Home" element={<Home />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contactus" element={<Contactus />} />
      </Routes>
      </div>
    </Router>
  );
}

export default App;
